import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { PitchTemplate } from '../data/pitchTemplates';

export const usePitchTemplateMeta = () => {
  const { t } = useTranslation();

  const getTemplateName = useCallback(
    (template: Pick<PitchTemplate, 'id' | 'name'>) =>
      t(`pitchTemplates.${template.id}.name`, { defaultValue: template.name }),
    [t],
  );

  const getTemplateDescription = useCallback(
    (template: Pick<PitchTemplate, 'id' | 'description'>) =>
      t(`pitchTemplates.${template.id}.description`, { defaultValue: template.description }),
    [t],
  );

  const getTemplateIndustry = useCallback(
    (template: Pick<PitchTemplate, 'id' | 'industry'>) =>
      t(`pitchTemplates.${template.id}.industry`, { defaultValue: template.industry }),
    [t],
  );

  return { getTemplateName, getTemplateDescription, getTemplateIndustry };
};
